import { jsx } from "react/jsx-runtime";
import ChatIcon from "@mui/icons-material/Chat";
import { validateTidalLicense } from "../../base/index.js";
function Chat(props) {
  return /* @__PURE__ */ jsx(
    ChatIcon,
    {
      "data-testid": "Chat",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Chat",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
Chat.tidalIconMeta = {
  categories: "chat,customerService",
  name: "Chat"
};
validateTidalLicense();
export {
  Chat
};
//# sourceMappingURL=Chat.js.map
